import { Box, Typography, Button, Paper } from '@mui/material';
import { useAuth } from '@claim-os/shared';

/**
 * Error component displayed when user has no organization membership.
 * Users cannot access the Portal without belonging to an organization.
 */
export function NoOrganizationError() {
  const { logout } = useAuth();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        p: 3,
      }}
    >
      <Paper
        sx={{
          p: 4,
          maxWidth: 480,
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" gutterBottom color="text.primary">
          No Organization Access
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Your account is not associated with any organization. Please contact
          your administrator to request access to an organization.
        </Typography>

        <Button variant="outlined" onClick={() => logout()}>
          Sign Out
        </Button>
      </Paper>
    </Box>
  );
}
